import React from 'react';

interface BlocksBarProps {
  total: number;
  filled: number | null | undefined;
  color: string;
  isEmpty?: boolean;
}

const BlocksBar: React.FC<BlocksBarProps> = ({
  total,
  filled,
  color,
  isEmpty = false,
}) => {

  if (isEmpty || filled === null || filled === undefined) {
    return (
      <div className="tw-flex tw-items-center tw-gap-[6px]">
        <div className="tw-flex tw-gap-[2px]">
          {Array(total)
            .fill('')
            .map(() => (
              <div
                className="tw-w-[10px] tw-h-4 tw-rounded-[3px] tw-bg-gray-border"
                style={{
                  background: '#D1D5DB',
                }}
              />
            ))}
        </div>
        <div className="tw-font-inter tw-font-medium tw-text-sm tw-text-gray-400">
          -
        </div>
      </div>
    );
  }

  return (
    <div className="tw-flex tw-items-center tw-gap-[6px]">
      <div className="tw-flex tw-gap-[2px]">
        {Array(total)
          .fill('')
          .map((_, i) => {
            let backgroundColor;
            if (i < Math.floor(filled)) {
              backgroundColor = color;
            } else if (i === Math.floor(filled) && filled % 1 !== 0) {
              const percentage = (filled % 1) * 100;
              backgroundColor = `linear-gradient(to right, ${color} ${percentage}%, #E5E7EB ${percentage}%)`;
            } else {
              backgroundColor = '#E5E7EB';
            }
            return (
              <div
                className="tw-w-[10px] tw-h-4 tw-rounded-[3px] tw-bg-gray-border"
                style={{
                  background: backgroundColor,
                }}
              />
            );
          })}
      </div>
      <div className="tw-font-inter tw-font-medium tw-text-sm">
        {filled}/{total}
      </div>
    </div>
  );
};

export default BlocksBar;
